module.exports = __webpack_public_path__ + "static/media/roundAbout2-Logo.d70dc6f4.jpg";